import React, { Component } from "react"
import ReactAvatarEditor from "react-avatar-editor"
import { Modal } from "../modals/Modal"
import "../../styles/_verify_candidate_modal.scss"
import "../../styles/_resume_listing_container.scss"
import $ from "jquery"
import _ from "underscore"

class ImageEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      position: { x: 0.5, y: 0.5 },
      scale: 1,
      rotate: 0,
    }
    this.handleSave = this.handleSave.bind(this)
    this.handleScale = this.handleScale.bind(this)
    this.setEditorRef = this.setEditorRef.bind(this)
    this.handlePositionChange = this.handlePositionChange.bind(this)
  }

  dataURItoBlob(dataURI) {
    if (_.isEmpty(dataURI)) {
      return null
    }
    var byteString = atob(dataURI.split(",")[1])
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0]

    var ab = new ArrayBuffer(byteString.length)
    var ia = new Uint8Array(ab)
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    var blob = new Blob([ab], { type: mimeString })
    return blob
  }

  handleSave(data) {
    const dataURI = this.editor.getImageScaledToCanvas().toDataURL()
    const img = this.dataURItoBlob(dataURI)
    this.props.onCrop(dataURI, img)
  }

  handleScale(e) {
    const scale = parseFloat(e.target.value)
    this.setState({ scale })
  }

  setEditorRef(editor) {
    if (editor) this.editor = editor
  }

  handlePositionChange(position) {
    this.setState({ position })
  }

  componentDidMount() {
    $(document).ready(function () {
      $("canvas").on("drop", function () {
        return false
      })
    })
  }

  render() {
    const { img, isOpen, onRequestHide, company = "" } = this.props
    const { scale } = this.state
    const width = 350, height = 350
    return (
      <Modal
        bsSize={"large"}
        className={`profile-pic-modal user-image-modal`}
        show={isOpen}
        onHide={onRequestHide}
      >
        <div
          className="modal-body"
        >
          <span className="icon-cross" onClick={onRequestHide} />
          <div className="heading">Add {company} logo</div>
          <div className="AvatarCropper-base">
            <ReactAvatarEditor
              ref={this.setEditorRef}
              border={0}
              scale={parseFloat(this.state.scale)}
              width={width}
              height={height}
              position={this.state.position}
              onPositionChange={this.handlePositionChange}
              rotate={parseFloat(this.state.rotate)}
              borderRadius={0}
              onSave={this.handleSave}
              image={img}
            />
            <br />
            <input
              name="scale"
              type="range"
              onChange={this.handleScale}
              min="1"
              max="2"
              step="0.01"
              defaultValue="1"
              style={{ width }}
              value={scale}
            />
            <br />
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-default"
            aria-label="reset"
            onClick={() => this.setState({ scale: 1 })}
          >
            Reset
          </button>
          <button
            type="button"
            className="btn btn-primary"
            aria-label=" click to crop and save"
            onClick={this.handleSave}
          >
            Crop & Upload
          </button>
        </div>
      </Modal>
    )
  }
}

export default ImageEditor
